/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, DestroyRef, computed, effect, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as Highcharts from 'highcharts';
import { ChatContent, ChartData } from '../../models/chat.model';
import {
    DEFAULT_TABLE_SORT,
    TableSortState,
    applyTableSort,
    nextTableSortState,
    tableSortAria,
    tableSortIcon
} from '../../utils/table-sort.util';

/**
 * Content Renderer Component
 * 
 * Renders chat message content with optional word-by-word streaming animation.
 * Supports various content types: text, markdown, code, tables, and lists.
 * 
 * @example
 * <app-content-renderer 
 *   [content]="messageContent"
 *   [isBotMessage]="true"
 *   [enableStreaming]="true"
 *   [streamingSpeed]="50">
 * </app-content-renderer>
 */
@Component({
    selector: 'app-content-renderer',
    templateUrl: './content-renderer.component.html',
    styleUrl: './content-renderer.component.scss',
    standalone: false
})
export class ContentRendererComponent {
    private static readonly MIN_CHART_WIDTH = 640;
    private static readonly CHART_WIDTH_PER_POINT = 80;

    private readonly sanitizer = inject(DomSanitizer);
    private readonly destroyRef = inject(DestroyRef);

    /** Content object to render */
    readonly content = input.required<ChatContent>();

    /** Enable/disable streaming animation */
    readonly enableStreaming = input(true);

    /** Controls if chat-level streaming is enabled */
    readonly enableChatStreaming = input(false);

    /** Speed of word streaming in milliseconds */
    readonly streamingSpeed = input(50);

    /** Identifies if this is a bot message (for streaming logic) */
    readonly isBotMessage = input(false);

    /** Currently displayed text during streaming */
    displayedText: string = '';

    /** Indicates if streaming is currently active */
    isStreaming: boolean = false;

    /** Indicates if streaming has completed */
    streamingComplete: boolean = false;

    /** Timeout reference for streaming animation */
    private streamingTimeout: any;

    /** Current word index during streaming */
    private currentWordIndex: number = 0;

    /** Full text before streaming */
    private fullText: string = '';

    /** Array of words to stream */
    private words: string[] = [];

    /** Highcharts reference exposed to the template for highcharts-chart binding. */
    readonly Highcharts: typeof Highcharts = Highcharts;

    /** Reactive sort state for the current table content (column index + direction). */
    private readonly tableSort = signal<TableSortState>(DEFAULT_TABLE_SORT);

    /** Rows of the current table sorted according to the current sort state. */
    readonly sortedTableRows = computed<string[][]>(() => {
        const data = this.content()?.data;
        const rows: string[][] = Array.isArray(data?.rows) ? data.rows : [];
        return applyTableSort(rows, this.tableSort());
    });

    /** Width used by chart container and chart options; recalculated only when content changes. */
    readonly chartContainerWidth = computed<number>(() => {
        const chartData = this.content().data as ChartData;
        const categoryCount = chartData.xAxis?.categories?.length ?? 0;
        const maxSeriesPoints = chartData.series.reduce((largestCount, series) => {
            return Math.max(largestCount, series.data.length);
        }, 0);
        const pointCount = Math.max(categoryCount, maxSeriesPoints);

        return Math.max(
            ContentRendererComponent.MIN_CHART_WIDTH,
            pointCount * ContentRendererComponent.CHART_WIDTH_PER_POINT
        );
    });

    /** Highcharts options for chart content, memoized by Angular computed signal dependencies. */
    readonly chartOptions = computed<Highcharts.Options>(() => {
        const d = this.content().data as ChartData;
        const chartWidth = this.chartContainerWidth();

        return {
            chart: {
                type: d.chartType,
                width: chartWidth,
                animation: true,
                style: { fontFamily: "'Roboto', sans-serif" },
                backgroundColor: 'rgba(236,245,252,0.35)',
                borderRadius: 15,
            },
            title: {
                text: d.title ?? '',
                style: { fontSize: '14px', fontWeight: '700', color: '#14171a' }
            },
            xAxis: {
                categories: d.xAxis?.categories,
                title: {
                    text: d.xAxis?.title ?? '',
                    style: { color: '#5b6065', fontSize: '12px', fontWeight: '400' }
                },
                crosshair: {
                    width: 1,
                    color: '#ccd3d9',
                    dashStyle: 'Solid'
                },
                labels: {
                    style: { color: '#334b63', fontSize: '12px' },
                },
                lineColor: '#ccd3d9',
                tickColor: '#ccd3d9'
            },
            yAxis: {
                title: {
                    text: d.yAxis?.title ?? '',
                    style: { color: '#5b6065', fontSize: '12px', fontWeight: '400' }
                },
                gridLineColor: '#e8eced',
                labels: {
                    style: { color: '#334b63', fontSize: '12px' }
                },
            },
            legend: {
                enabled: true,
                itemStyle: {
                    color: '#14171a',
                    fontWeight: '400',
                    fontSize: '12px'
                },
                itemHoverStyle: { color: '#006bd3' }
            },
            tooltip: {
                shared: true,
                backgroundColor: '#fff',
                borderColor: '#ccd3d9',
                style: {
                    color: '#14171a',
                    fontSize: '12px'
                },
                followPointer: true
            },
            plotOptions: {
                line: {
                    marker: { enabled: false, symbol: 'circle', radius: 3 },
                    lineWidth: 2,
                },
            },
            series: d.series as Highcharts.SeriesOptionsType[],
            exporting: { enabled: false },
            credits: { enabled: false }
        };
    });

    constructor() {
        // Register cleanup on destroy
        this.destroyRef.onDestroy(() => {
            this.stopStreaming();
        });

        // React to content changes
        effect(() => {
            const contentValue = this.content();
            if (contentValue) {
                this.initializeStreaming();
            }
        });
    }

    /**
     * Initialize word-by-word streaming display for bot messages
     */
    private initializeStreaming(): void {
        // Only apply streaming for bot messages, not user messages
        const shouldStream = this.enableStreaming() &&
            this.isBotMessage() && this.enableChatStreaming() &&
            this.content() &&
            (this.content().type === 'text' || this.content().type === 'markdown' || this.content().type === 'code');

        if (!shouldStream) {
            this.displayedText = this.getContentText();
            this.streamingComplete = true;
            return;
        }

        this.stopStreaming();
        this.fullText = this.getContentText();
        this.words = this.splitIntoWords(this.fullText);
        this.displayedText = '';
        this.currentWordIndex = 0;
        this.isStreaming = true;
        this.streamingComplete = false;
        this.startStreaming();
    }

    /**
     * Start word-by-word streaming
     */
    private startStreaming(): void {
        if (this.currentWordIndex < this.words.length) {
            // Add space before word (except for the first word)
            if (this.currentWordIndex > 0) {
                this.displayedText += ' ';
            }

            this.displayedText += this.words[this.currentWordIndex];
            this.currentWordIndex++;

            this.streamingTimeout = setTimeout(() => {
                this.startStreaming();
            }, this.streamingSpeed());
        } else {
            this.completeStreaming();
        }
    }

    /**
     * Complete streaming display
     */
    private completeStreaming(): void {
        this.isStreaming = false;
        this.streamingComplete = true;
        this.displayedText = this.fullText;
    }

    /**
     * Stop current streaming process
     */
    private stopStreaming(): void {
        if (this.streamingTimeout) {
            clearTimeout(this.streamingTimeout);
            this.streamingTimeout = null;
        }
        this.isStreaming = false;
    }

    /**
     * Get text content for streaming
     */
    private getContentText(): string {
        const contentValue = this.content();
        if (!contentValue) return '';

        switch (contentValue.type) {
            case 'text':
            case 'markdown':
                return contentValue.data || '';
            case 'code':
                return contentValue.data || '';
            default:
                return '';
        }
    }

    /**
     * Split text into words while preserving line breaks and formatting
     */
    private splitIntoWords(text: string): string[] {
        if (!text) return [];

        // Simple word splitting that preserves punctuation with words
        return text.split(/\s+/).filter(word => word.length > 0);
    }

    /**
     * Check if streaming should be applied for current content
     */
    shouldApplyStreaming(): boolean {
        const contentValue = this.content();
        return this.enableStreaming() &&
            this.isBotMessage() &&
            contentValue &&
            (contentValue.type === 'text' || contentValue.type === 'markdown' || contentValue.type === 'code');
    }

    /**
     * Check if data is in table format
     * @param data - Data to check
     * @returns True if data has table structure
     */
    isTableData(data: any): boolean {
        return data && typeof data === 'object' && data.headers && data.rows;
    }

    /**
     * Check if data is in list format
     * @param data - Data to check
     * @returns True if data has list structure
     */
    isListData(data: any): boolean {
        return data && typeof data === 'object' && data.items && Array.isArray(data.items);
    }

    /**
     * Format text with markdown-like syntax
     * Converts **bold**, *italic*, `code`, and newlines to HTML
     * 
     * @param text - Text to format
     * @returns Formatted HTML string
     */
    formatText(text: string): string {
        if (!text) return '';

        if (text.includes('<table') && text.includes('</table>')) {
            return text;
        }

        const lines = text.split('\n');
        const result: string[] = [];
        let i = 0;

        while (i < lines.length) {
            const line = lines[i];

            // Markdown table detection (pipe-delimited)
            if (line.trim().startsWith('|') && line.trim().endsWith('|')) {
                const tableLines: string[] = [];
                while (i < lines.length && lines[i].trim().startsWith('|') && lines[i].trim().endsWith('|')) {
                    tableLines.push(lines[i]);
                    i++;
                }
                if (tableLines.length >= 2) {
                    const headers = this.parseTableRow(tableLines[0]);
                    const startRow = tableLines[1].includes('---') ? 2 : 1;
                    let tableHtml = '<table class="chat-table"><thead><tr>';
                    headers.forEach(h => tableHtml += `<th>${this.formatInline(h)}</th>`);
                    tableHtml += '</tr></thead><tbody>';
                    for (let r = startRow; r < tableLines.length; r++) {
                        const cells = this.parseTableRow(tableLines[r]);
                        tableHtml += '<tr>';
                        cells.forEach(c => tableHtml += `<td>${this.formatInline(c)}</td>`);
                        tableHtml += '</tr>';
                    }
                    tableHtml += '</tbody></table>';
                    result.push(tableHtml);
                }
                continue;
            }

            // Tab-separated table detection
            if (line.includes('\t') && i + 1 < lines.length && lines[i + 1].includes('\t')) {
                const tableLines: string[] = [];
                while (i < lines.length && lines[i].includes('\t')) {
                    tableLines.push(lines[i]);
                    i++;
                }
                if (tableLines.length >= 2) {
                    const headers = tableLines[0].split('\t').map(c => c.trim());
                    let tableHtml = '<table class="chat-table"><thead><tr>';
                    headers.forEach(h => tableHtml += `<th>${this.formatInline(h)}</th>`);
                    tableHtml += '</tr></thead><tbody>';
                    for (let r = 1; r < tableLines.length; r++) {
                        const cells = tableLines[r].split('\t').map(c => c.trim());
                        tableHtml += '<tr>';
                        cells.forEach(c => tableHtml += `<td>${this.formatInline(c)}</td>`);
                        tableHtml += '</tr>';
                    }
                    tableHtml += '</tbody></table>';
                    result.push(tableHtml);
                }
                continue;
            }

            // Headers
            if (line.startsWith('### ')) { result.push(`<h3>${this.formatInline(line.slice(4))}</h3>`); i++; continue; }
            if (line.startsWith('## ')) { result.push(`<h2>${this.formatInline(line.slice(3))}</h2>`); i++; continue; }
            if (line.startsWith('# ')) { result.push(`<h1>${this.formatInline(line.slice(2))}</h1>`); i++; continue; }

            // Horizontal rule
            if (/^[-*_]{3,}\s*$/.test(line.trim())) { result.push('<hr>'); i++; continue; }

            // Unordered list
            if (/^\s*[-*+]\s+/.test(line)) {
                let listHtml = '<ul>';
                while (i < lines.length && /^\s*[-*+]\s+/.test(lines[i])) {
                    listHtml += `<li>${this.formatInline(lines[i].replace(/^\s*[-*+]\s+/, ''))}</li>`;
                    i++;
                }
                listHtml += '</ul>';
                result.push(listHtml);
                continue;
            }

            // Ordered list
            if (/^\s*\d+\.\s+/.test(line)) {
                let listHtml = '<ol>';
                while (i < lines.length && /^\s*\d+\.\s+/.test(lines[i])) {
                    listHtml += `<li>${this.formatInline(lines[i].replace(/^\s*\d+\.\s+/, ''))}</li>`;
                    i++;
                }
                listHtml += '</ol>';
                result.push(listHtml);
                continue;
            }

            // Regular line
            if (line.trim().length === 0) {
                result.push('<br>');
            } else {
                result.push(this.formatInline(line));
            }
            i++;
        }

        return result.join('\n');
    }

    private parseTableRow(line: string): string[] {
        return line.trim().slice(1, -1).split('|').map(cell => cell.trim());
    }

    private formatInline(text: string): string {
        return text
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            .replace(/`(.*?)`/g, '<code>$1</code>')
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
    }

    /**
     * Copy text to clipboard
     * Uses modern Clipboard API if available
     * 
     * @param text - Text to copy
     */
    copyToClipboard(text: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                // Could show a toast notification here
                console.log('Copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        }
    }

    /**
     * Safely sanitize HTML content for rendering
     */
    getSafeHtml(htmlContent: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }

    /**
     * Additional methods for table rendering support
     */
    getTableDataSource(): any[] {
        const contentValue = this.content();
        if (!this.isTableData(contentValue.data)) return [];

        return contentValue.data.rows.map((row: string[]) => {
            const rowObj: any = {};
            contentValue.data.headers.forEach((header: string, index: number) => {
                rowObj[`col_${index}`] = row[index] || '';
            });
            return rowObj;
        });
    }

    getTableColumns(): string[] {
        const contentValue = this.content();
        if (!this.isTableData(contentValue.data)) return [];

        return contentValue.data.headers.map((_: string, index: number) => `col_${index}`);
    }

    getTableAsText(): string {
        const contentValue = this.content();
        if (!this.isTableData(contentValue.data)) return '';

        const headerRow = contentValue.data.headers.join('\t');
        const dataRows = contentValue.data.rows.map((row: string[]) => row.join('\t'));
        return [headerRow, ...dataRows].join('\n');
    }

    onTableHeaderSort(colIndex: number): void {
        const nextSortState = nextTableSortState(this.tableSort(), colIndex);
        this.tableSort.set(nextSortState);
    }

    getTableSortIcon(colIndex: number): string {
        return tableSortIcon(this.tableSort(), colIndex);
    }

    getTableSortAria(colIndex: number): 'ascending' | 'descending' | 'none' {
        return tableSortAria(this.tableSort(), colIndex);
    }

}